import sliceCreator from '../../index.js';
import {GET_ALL_MACHINES} from '../../../constants/index.js';
const _getMachineAction = sliceCreator('GET_ALL_MACHINES', GET_ALL_MACHINES, 'get');

const { asyncAction: getMachineAction, reducer, clearData: clearGetMachineAction } = _getMachineAction;

export default reducer;

export {
    getMachineAction,
    clearGetMachineAction
}